import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { WALLETS_ROUTE_PATHS } from './config';

export const WALLETS_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-wallets',
    path: WALLETS_ROUTE_PATHS.wallets,
    component: lazy(() => import('./pages/wallets-page')),
    layout: 'default',
    permissions: { scopes: ['movements-wallets'] },
    menu: {
      title: 'pages.movements.wallets.title',
    },
  },
];
